export default __webpack_public_path__ + "static/media/tiger3.5451337c.png";